import styled from "styled-components";

export const StyledNotFound = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px;
    flex-shrink: 1;
    flex-grow: 1;
    height: 100%;
    svg {
        display: block;
    }
    a {
        font-size: 16px;
        margin-top: 20px;
        color: ${({ theme }) => theme.colors.darkGrey};
    }
`;
